<template>
  <div v-if="parentEntity" class="mt-3">
    <right-panel class="float-right" id="sidebar-new-data" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <right-panel class="float-right" id="sidebar-info-data" width="800px">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("data.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <h5>{{ $t("data.used-places") }}</h5>

          <table v-if="info && info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("department.text") }}</th>
                <th>{{ $t("process.text") }}</th>
                <th>{{ $t("datasource.text") }}</th>
                <th class="text-center">{{ $t("common.edit") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.department.name | translate }}
                </td>
                <td>
                  {{ i.process.name | translate }}
                </td>
                <td>
                  {{ i.name | translate }}
                </td>
                <td style="text-align: center;">
                  <a href="javascript:;void(0);" @click="deleteByIdFromHierarchy(i)" v-b-tooltip.hover :title="$t('common.delete')">
                    <i class="bx bx-trash-alt text-danger"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <!-- Begin: Pagination -->

        <div v-if="info" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
    </right-panel>

    <!-- Begin : Inventory -->
    <template>
      <right-panel class="float-right" id="sidebar-data-inventory" width="1400px" icon="" @hidden="bulkUpdateRightPanelClosed">
        <b-tabs v-if="selectedBox" nav-class="nav-tabs-custom p-2 ml-3" v-model="activeTab" content-class="mt-1">
          <!-- BEGIN TAB-->
          <b-tab>
            <template v-slot:title>
              <span>
                {{ $t("inventory.filter.inventory-features") }}
              </span>
            </template>

            <div v-if="dataInventory" class="pl-5 pr-5">
              <h3>{{ $t("data.inventory", { data: $options.filters.translate(selectedBox.name) }) }}</h3>

              <!--Disposal Method-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.data-disposal-method-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("disposal-method.text") }}
                </h4>
                <b-collapse id="data-disposal-method-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!dataInventory.disposalMethods || dataInventory.disposalMethods.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <div v-for="item in dataInventory.disposalMethods" :key="item._id" class="mb-1">
                      <i class="bx bx-trash text-danger hand" @click="removeDisposalMethod(selectedBox._id, item._id)"></i> {{ item.name | translate }}
                    </div>

                    <span class="text-primary hand" @click="editDisposalMethod(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!--Disposal Period-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.data-disposal-period-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("disposal-method.periodic") }}
                </h4>
                <b-collapse id="data-disposal-period-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <h4>
                      {{ dataInventory.disposalPeriod | period }}
                    </h4>
                    <span class="text-warning hand" @click="editDisposalPeriod(selectedBox)"> <i class="bx bx-pencil"></i> {{ $t("common.edit") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!--Access And Restrictions-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.data-access-and-restriction-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("access-restriction.text") }}
                </h4>
                <b-collapse id="data-access-and-restriction-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!dataInventory.accessAndRestrictions || dataInventory.accessAndRestrictions.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <b-row v-for="(accessAndRestriction, index) in dataInventory.accessAndRestrictions" :key="accessAndRestriction._id + index">
                      <b-col v-if="accessAndRestriction">
                        <i class="bx bx-trash text-danger hand hidden" @click="removeAccessAndRestriction(selectedBox._id, accessAndRestriction._id)"></i>

                        {{ accessAndRestriction.accessor.name | translate }}
                      </b-col>
                      <b-col v-if="accessAndRestriction">{{ accessAndRestriction.restriction.name | translate }}</b-col>
                    </b-row>

                    <span class="text-primary hand" @click="addAccessAndRestriction(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

            <content-loading v-if="isDataInventoryLoading" />
          </b-tab>

          <b-tab>
            <template v-slot:title>
              <span>
                {{ $t("inventory.bulk-update.text") }}
              </span>
            </template>

            <BulkUpdateView @onUpdated="onBulkUpdated" />
          </b-tab>
        </b-tabs>
      </right-panel>
      <template v-if="selectedBox">
        <right-panel class="float-right" id="sidebar-new-data-disposal-method" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DataDisposalMethodForm />
          </div>
        </right-panel>
        <right-panel class="float-right" id="sidebar-data-disposal-period" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DataDisposalPeriodForm id="sidebar-data-disposal-period" />
          </div>
        </right-panel>
        <right-panel class="float-right" id="sidebar-new-data-access-and-restriction" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DataAccessAndRestrictionForm id="sidebar-new-data-access-and-restriction" />
          </div>
        </right-panel>
      </template>
    </template>
    <!-- End : Inventory -->

    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          <span
            v-if="categoryEntity"
            v-html="
              $t('data.owned-list-with-category', {
                department: $options.filters.translate(parentEntity.process.department.name),
                process: $options.filters.translate(parentEntity.process.name),
                name: $options.filters.translate(parentEntity.name),
                category: $options.filters.translate(categoryEntity.name),
              })
            "
          >
          </span>
          <span
            v-else
            v-html="
              $t('data.owned-list', {
                department: $options.filters.translate(parentEntity.process.department.name),
                process: $options.filters.translate(parentEntity.process.name),
                name: $options.filters.translate(parentEntity.name),
              })
            "
          >
          </span>
        </span>
      </div>
      <div>
        <div class="search2 mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="text">
            {{ item.name | translate }}
          </div>
          <div class="actions d-flex justify-content-center">
            <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
              <i class="iconoir-trash"></i>
            </div>
            <div class="action" @click="fetchInfo(item.data)" v-on:click.stop v-b-toggle="'sidebar-info-data'" v-b-tooltip.hover :title="$t('data.used-places')">
              <i class="iconoir-info-circle"></i>
            </div>

            <div class="action" @click="edit(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>

            <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
          </div>
        </div>

        <div class="ds-card--item2" @click="openRightPanel">
          <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
    </div>
  </div>
</template>

<script>
import DataAccessAndRestrictionForm from "@modules/inventory/component/access-and-restriction/data-access-and-restriction-form";
import BulkUpdateView from "@modules/inventory/component/bulk-update/bulk-update-view";
import DataDisposalMethodForm from "@modules/inventory/component/disposal-method/data-disposal-method-form";
import DataDisposalPeriodForm from "@modules/inventory/component/disposal-period/data-disposal-period-form";
import Form from "../../datasource-data/organization-datasource-data-form";

export default {
  components: { Form, DataDisposalMethodForm, DataAccessAndRestrictionForm, DataDisposalPeriodForm, BulkUpdateView },
  data() {
    return {
      nameFilter: undefined,
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: {},
      },

      infoRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
      activeTab: null,
    };
  },
  computed: {
    parentEntity() {
      return this.$store.getters["entityBoxes/datasource"];
    },
    categoryEntity() {
      return this.$store.getters["entityBoxes/dataCategory"];
    },
    pagination() {
      return this.$store.getters["organizationDatasourceData/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDatasourceData/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },

    infoItem() {
      return this.$store.getters["organizationData/infoItem"];
    },
    info() {
      return this.$store.getters["organizationData/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationData/isInfoLoading"];
    },
    //inventory

    productInventoryStore() {
      return this.currentProduct == "GDPR" ? "gdprInventory" : "kvkkInventory";
    },
    dataInventory() {
      const inventory = this.$store.getters[this.productInventoryStore + "/dataInventory"];

      if (!inventory || !this.selectedBox?._id) return null;
      return inventory[this.selectedBox._id];
    },
    isDataInventoryLoading() {
      return this.$store.getters[this.productInventoryStore + "/isDataInventoryLoading"];
    },
    selectedBox() {
      return this.$store.getters["entityBoxes/data"];
    },
  },
  watch: {
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    parentEntity(item) {
      this.debounce(() => this.paginate());
    },
    categoryEntity(item) {
      this.debounce(() => this.paginate());
    },

    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clearFrom", "data");
      this.$store.commit("organizationDatasourceData/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedData = this.$store.getters["entityBoxes/data"];
        if (selectedData) {
          await this.selectBox(selectedData);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    openRightPanel() {
      const datasource = this.$store.getters["entityBoxes/datasource"];
      this.$store.commit(`organizationProcessDatasource/selectedEntity`, datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data");
    },
    selectedBoxStyle(item) {
      if (this.selectedBox?._id == item._id) {
        return "bg-main text-white";
      }
    },

    async paginate() {
      if (!this.parentEntity) {
        return;
      }
      const request = { ...this.request };
      request.query = {
        ...request.query,
        datasource: { value: { _id: this.parentEntity._id }, isObject: true },
      };

      if (this.categoryEntity) {
        request.query.category = {
          value: { _id: this.categoryEntity._id },
          isObject: true,
        };
      }

      await this.$store.dispatch("organizationDatasourceData/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDatasourceData/delete", item._id);
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    interceptForSetParent(payload) {
      payload.datasource = this.parentEntity;
    },

    async deleteByIdFromHierarchy(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDatasourceData/delete", item.rel_id);
        this.$toast.success(this.$t("common.delete-successful"));
        this.fetchInfo();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.delete-failed") });
      }
    },

    edit(item) {
      this.$store.commit("organizationDatasourceData/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationDatasourceData/editedEntity");
      this.$store.commit("organizationDatasourceData/copingEntity");
      // this.$store.dispatch("organizationDatasourceData/resetForm");
    },
    bulkUpdateRightPanelClosed() {
      this.$store.commit("inventoryFilter/clear");
    },

    selectBox(item) {
      this.$store.dispatch("entityBoxes/selectData", item);
    },

    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationData/fetchInfo", { item, pagination: this.infoRequest });
    },

    //inventory
    onBulkUpdated() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-data-inventory");
    },
    async inventoryRightPanelClosed() {
      const datas = [{ _id: this.selectedBox._id }];
      await this.$store.dispatch(this.productInventoryStore + "/fetchDataInventory", { datas });
    },

    async showInventoryPanel(item) {
      this.$store.commit("entityBoxes/data", item);
      this.$store.commit("organizationDatasourceData/selectedEntity", item);

      this.$store.commit("inventoryFilter/clear");
      this.$store.commit("inventoryFilter/department", item.datasource.process.department);
      this.$store.commit("inventoryFilter/process", item.datasource.process);
      this.$store.commit("inventoryFilter/datasource", item.datasource);
      this.$store.commit("inventoryFilter/data", item);

      const datas = [item];

      this.$root.$emit("bv::toggle::collapse", "sidebar-data-inventory");
      await this.$store.dispatch(this.productInventoryStore + "/fetchDataInventory", { datas });
    },

    editDisposalMethod(data) {
      this.$store.commit("dataDisposalMethod/editedData", data);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data-disposal-method");
    },

    async removeDisposalMethod(dataId, disposalMethodId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("dataDisposalMethod/delete", disposalMethodId);
        this.$store.commit(this.productInventoryStore + "/removeDisposalMethod", { dataId, disposalMethodId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    editDisposalPeriod(data) {
      this.$store.commit("dataDisposalPeriod/editedData", data);
      this.$root.$emit("bv::toggle::collapse", "sidebar-data-disposal-period");
    },

    addAccessAndRestriction(item) {
      this.$store.commit("dataAccessAndRestriction/editedData", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data-access-and-restriction");
    },

    async removeAccessAndRestriction(dataId, accessAndRestrictionId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("dataAccessAndRestriction/delete", accessAndRestrictionId);
        this.$store.commit(this.productInventoryStore + "/removeAccessAndRestriction", { dataId, accessAndRestrictionId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>

<style scoped>
.when-opened,
.when-closed {
  font-size: 20px;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
